module.exports = __webpack_public_path__ + "img/hoja.896b78b8.svg";